import { ValidationRuleFragment } from '@websky/graphql';
import { DeepPartial } from '../../../../types';

export const resolveDocTypeDefaultValue = (
	defaultValue: string,
	isEditable: boolean | null | undefined,
	options: DeepPartial<ValidationRuleFragment>['options']
): string => {
	if (!isEditable) {
		return defaultValue;
	}

	if (options?.some(option => option?.value === defaultValue)) {
		return defaultValue;
	}

	const firstOptionValue = options?.[0]?.value;

	if (firstOptionValue && firstOptionValue !== defaultValue) {
		return firstOptionValue;
	}

	return defaultValue;
};
